import React from "react";
import { Box, ButtonBase, SxProps, Theme } from "@mui/material";
import { MONO_FONT } from "@/shared/typography";

interface KbdProps {
  children: React.ReactNode;
  component?: "span" | "button";
  onClick?: () => void;
  disabled?: boolean;
  "aria-label"?: string;
  "data-testid"?: string;
}

export function Kbd({
  children,
  component,
  onClick,
  disabled,
  "aria-label": ariaLabel,
  "data-testid": dataTestId,
}: KbdProps) {
  const kbdSx: SxProps<Theme> = {
    border: 1,
    borderColor: "divider",
    borderRadius: "5px",
    px: 1,
    py: 0.25,
    fontFamily: MONO_FONT,
    fontSize: 10,
    color: "text.secondary",
    display: "inline-flex",
    alignItems: "center",
    minHeight: 0,
  };

  const shouldUseButton = component === "button" || Boolean(onClick);

  if (shouldUseButton) {
    return (
      <ButtonBase
        sx={kbdSx}
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel}
        data-testid={dataTestId}
      >
        {children}
      </ButtonBase>
    );
  }

  return (
    <Box component="span" sx={kbdSx} data-testid={dataTestId}>
      {children}
    </Box>
  );
}